(function($) {

	'use strict';

	var init = function() {
        //MENU DROPDOWN

		$(window).on('scroll', stickyMenu);
		stickyMenu();
		

		$('.header__main__burger').on('click', function(){
			$('.header__main__burger').toggleClass('open');
			$('.header__main__nav').toggleClass('show');
            $('html').toggleClass('popup-open');
		});
		
		// Ouverture des sous-menus sur le menu mobile
		$('.menu-item-has-children > a').on('click', menu_n1);
		
		// Init with current menu open on mobile
		if(window.innerWidth < 992){
			$('li.current-menu-parent > .sub-menu').slideToggle(0);
		}

	};

	var stickyMenu = function(e) {
		if( !$('.header').hasClass('sticky') && $(document).scrollTop() > 200 ){
			$('.header').addClass('sticky');
			$('body').css('padding-top', '200px');
        } else if( $('.header').hasClass('sticky') && $(document).scrollTop() <= 200 ){
            $('.header').removeClass('sticky');
			$('body').css('padding-top', '0');
        }
	}

	var menu_n1 = function(e){
		if(window.innerWidth < 992){
			e.preventDefault();
			$(this).siblings('.sub-menu').slideToggle(300);
		}
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);
